import React, { useState } from "react"
import { toAbsoluteUrl } from "@common-metronic/helpers"
import MyLoadingOverlay from "../../../../../common/components/MyLoadingOverlay"
import MyTooltip from "@common-utils/MyTooltip"
import { useBonsLivraisonManquantsOfGivenMonthListingListContext } from "./_BonsLivraisonManquantsOfGivenMonthListingList"
import { useBonsLivraisonManquantsOfGivenMonthListingContext } from "./BonsLivraisonManquantsOfGivenMonthListing"
import { getSelectedItemPlusPreviousAndNextItem } from "./core/_helpers"
import FileAndDriveHelper from "@common-helpers/FileAndDriveHelper"
import { IBonsLivraisonManquantsOfGivenMonthItemResponseModel, IBonsLivraisonManquantsOfGivenMonthResponseModel } from "./core/_models"
import { Link } from "react-router-dom"
import MyModal from "@common-utils/MyModal"
import PtfPeriodeBonCommandeAddBonLivraisonForm from "../../ptf/actions/_PtfPeriodeBonCommandeAddBonLivraisonForm"
import PtfPeriodeBonCommandeAddLivrableForm from "../../ptf/actions/_PtfPeriodeBonCommandeAddLivrableForm"
import { useQueryClient } from "react-query"

const ListItem = ({ item, handleClickItemForPreview, isItemSelected, isItemLoading }: IListItemPropsModel) => {
     const queryClient = useQueryClient()
     const globalContext = useBonsLivraisonManquantsOfGivenMonthListingContext()
     const listContext = useBonsLivraisonManquantsOfGivenMonthListingListContext()
     const [isAvatarLoading, setIsAvatarLoading] = useState<boolean>(true)
     const [isAddingBonLivraisonInModal, setIsAddingBonLivraisonInModal] = useState<boolean>(false)
     const ptf = item.bc.propalPeriode?.propal

     function handleOnCheckItem() {
          if (!globalContext.isBulkSelectionEnabled.checkedElementsInPage.includes(item.bc.id as number)) {
               globalContext.setIsBulkSelectionEnabled(prev => ({
                    ...prev,
                    checkedElementsInPage: [...prev.checkedElementsInPage, item.bc.id as number],
                    areAllElementsInAllPagesChecked: false,
               }))
          } else {
               globalContext.setIsBulkSelectionEnabled(prev => ({
                    ...prev,
                    checkedElementsInPage: prev.checkedElementsInPage.filter(id => id !== item.bc.id),
                    areAllElementsInAllPagesChecked: false,
               }))
          }
     }

     function handleSubmitAddBonLivraisonCallback() {
          globalContext.setItemInPreview(null)
          queryClient.setQueryData<IBonsLivraisonManquantsOfGivenMonthResponseModel | undefined>(
               globalContext.REACT_QUERY_KEY_GET_LISTING,
               (prev: IBonsLivraisonManquantsOfGivenMonthResponseModel | undefined) => {
                    if (prev?.data && prev.data.length > 0) {
                         prev.pageEnd -= 1
                         prev.totalElementsInAllPages -= 1
                         prev.totalElementsInPage -= 1
                         prev.data = prev.data.filter(item_ => item_.bc.id !== item.bc.id)
                    }

                    return prev
               }
          )
          setIsAddingBonLivraisonInModal(false)
     }

     return (
          <MyLoadingOverlay isActive={isItemLoading}>
               <>
                    <div
                         className={`${isItemSelected ? "border-start border-2 border-primary" : ""}`}
                         onClick={e => handleClickItemForPreview(e)}
                         ref={isItemSelected ? listContext.selectedItemRef : null}
                    >
                         <div className={`p-4 ${isItemSelected ? "mb-4 bg-light" : "cursor-pointer"}`}>
                              {/* checkbox, Avatar, nom & métier*/}
                              <div className={"d-flex justify-content-between"}>
                                   {/* checkbox */}
                                   {globalContext.isBulkSelectionEnabled.enabled && (
                                        <div className={"form-check form-check-custom form-check-solid form-check-sm me-4"}>
                                             <input
                                                  type="checkbox"
                                                  className={"form-check-input cursor-pointer border border-secondary not-concerned-by-preview"}
                                                  checked={globalContext.isBulkSelectionEnabled.checkedElementsInPage.includes(item.bc.id as number)}
                                                  onChange={() => handleOnCheckItem()}
                                             />
                                        </div>
                                   )}

                                   <div className={"d-flex align-items-center"}>
                                        {/* Left */}
                                        <MyLoadingOverlay isActive={isAvatarLoading} styles={{ height: "50px", width: "50px", borderRadius: "50%" }} size={"sm"}>
                                             <div className={"d-flex"}>
                                                  <img
                                                       src={
                                                            ptf?.client?.googleDriveIdAvatar
                                                                 ? FileAndDriveHelper.getThumbnailDriveUrl(ptf.client.googleDriveIdAvatar as string)
                                                                 : toAbsoluteUrl("/media/svg/files/blank-image.svg")
                                                       }
                                                       onLoad={() => setIsAvatarLoading(false)}
                                                       style={{ height: "50px", width: "50px", borderRadius: "50%" }}
                                                       alt="Avatar"
                                                  />
                                             </div>
                                        </MyLoadingOverlay>

                                        {/* Middle */}
                                        <div className={"ms-4"}>
                                             <div className={"d-flex"}>
                                                  <span className={"fw-bold fs-5"}>{ptf?.client?.nom}</span>
                                             </div>
                                             <div>
                                                  <Link to={`/client/ptf/${ptf?.id}/details`} target={"_blank"}>
                                                       {ptf?.reference}
                                                  </Link>{" "}
                                                  <span>( {ptf?.typeLabelShort} )</span>
                                             </div>
                                        </div>
                                   </div>

                                   {/* Right side */}
                                   <div className="d-flex align-items-center">
                                        <span className={"badge badge-dark"}>Facturable par {ptf?.entiteFacturation?.nom}</span>
                                   </div>
                              </div>
                         </div>

                         {isItemSelected && (
                              <>
                                   <div className={"d-flex align-items-center px-4 pb-4"}>
                                        <div className={"col-10"}>
                                             {/* Responsable */}
                                             <div className={`d-flex align-items-center mb-2`}>
                                                  <span className="fas fa-user fs-5 w-25px" /> {ptf?.personnel?.prenomNom}
                                             </div>

                                             {/* Consultants */}
                                             <div className={`d-flex align-items-center flex-wrap`}>
                                                  <span className="fas fa-users fs-5 w-25px" />
                                                  {item.consultantsAttachesToPtf.length > 0 ? (
                                                       item.consultantsAttachesToPtf?.map((item_, key_) => (
                                                            <div>
                                                                 <Link to={`/business/consultants/${item_.id}/details`} target={"_blank"}>
                                                                      {item_.prenomNom}
                                                                 </Link>{" "}
                                                                 {key_ + 1 < item.consultantsAttachesToPtf.length && <span className={"me-1"}>,</span>}
                                                            </div>
                                                       ))
                                                  ) : (
                                                       <span className={"text-muted"}>Aucun consultant</span>
                                                  )}
                                             </div>
                                        </div>
                                        <div className="col text-end">
                                             <div>
                                                  <MyTooltip title={"Ajouter le BL manquant"}>
                                                       <button
                                                            type={"button"}
                                                            className={`btn btn-outline btn-outline-success btn-sm btn-icon rounded-circle mb-2`}
                                                            onClick={() => setIsAddingBonLivraisonInModal(true)}
                                                       >
                                                            <i className="fas fa-plus-circle fs-4" />
                                                       </button>
                                                  </MyTooltip>
                                             </div>
                                        </div>
                                   </div>

                                   {isAddingBonLivraisonInModal && (
                                        <MyModal
                                             title={
                                                  <span>
                                                       {ptf?.reference} - Ajout d'un {ptf?.type === "TYPE_ASSISTANCE_TECHNIQUE" ? "bon de livraison" : "livrable"}
                                                  </span>
                                             }
                                             show={true}
                                             onCloseCallback={() => setIsAddingBonLivraisonInModal(false)}
                                             size={"lg"}
                                        >
                                             {ptf?.type === "TYPE_ASSISTANCE_TECHNIQUE" ? (
                                                  <PtfPeriodeBonCommandeAddBonLivraisonForm
                                                       bc_ID={item.bc!.id as number}
                                                       dateDebut={item.mois.startOf("month").format("YYYY-MM-DD")}
                                                       dateFin={item.mois.endOf("month").format("YYYY-MM-DD")}
                                                       handleSubmitCallback={handleSubmitAddBonLivraisonCallback}
                                                  />
                                             ) : (
                                                  <PtfPeriodeBonCommandeAddLivrableForm bc_ID={item.bc!.id as number} handleSubmitCallback={handleSubmitAddBonLivraisonCallback} />
                                             )}
                                        </MyModal>
                                   )}
                              </>
                         )}
                    </div>
               </>
          </MyLoadingOverlay>
     )
}

const BonsLivraisonManquantsOfGivenMonthListingListItem = ({ item, index }: { item: IBonsLivraisonManquantsOfGivenMonthItemResponseModel; index: number }) => {
     const context = useBonsLivraisonManquantsOfGivenMonthListingContext()

     const isItemSelected: boolean = context.itemInPreview !== null && context.itemInPreview.selectedItem.bc.id === item.bc.id
     const isItemLoading: boolean = context.itemInPreview !== null && context.itemInPreview.selectedItem.bc.id === item.bc.id && context.itemInPreview.isSelectedItemLoading

     // Shows item in preview
     function handleClickItemForPreview(e: React.MouseEvent<any>) {
          const clickedElement = e.target as HTMLElement
          // .not-concerned-by-preview elements are not concerned by the click
          if (!clickedElement.classList.contains("not-concerned-by-preview") && context.itemInPreview?.selectedItem.bc.id !== item.bc.id) {
               context.setAreFiltersVisible(false)

               context.setItemInPreview({
                    ...getSelectedItemPlusPreviousAndNextItem(item, index, context.listingQuery.data!.data, context.listingQuery.data!.page, context.listingQuery.data!.totalPages),
               })
          }
     }

     return <ListItem item={item} handleClickItemForPreview={handleClickItemForPreview} isItemSelected={isItemSelected} isItemLoading={isItemLoading} />
}

interface IListItemPropsModel {
     item: IBonsLivraisonManquantsOfGivenMonthItemResponseModel
     handleClickItemForPreview: (e: React.MouseEvent<any>) => void
     isItemSelected: boolean
     isItemLoading: boolean
}

export default BonsLivraisonManquantsOfGivenMonthListingListItem
